var Symbol = require("./_Symbol"), isArguments = require("./isArguments"), isArray = require("./isArray");
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : void 0;
function isFlattenable(value) {
  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;
